import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'appredux/reducers';

import useDepotStats from '../useDepotStats';
import OrderCountCard from './OrderCountCard';
import {Skeleton} from '@material-ui/lab';

import './OrderCountWidget.scss';

export default function OrdersCountWidget() {
  /* current dashboard date-range (from header) */
  const {start, end} = useSelector((s: RootState) => s.rdwDateFilter);

  /* stats for that window */
  const {loading, stats} = useDepotStats(start, end);

  // Ensure stats is always defined with default values
  const safeStats = stats || {
    invoicesCount: 0,
    paidInvoicesCount: 0,
    unpaidInvoicesCount: 0,
    inProgressInvoicesCount: 0,
  };

  // Only show skeleton if loading AND no stats available
  if (loading && !stats) {
    return <Skeleton variant="rect" height={160} style={{borderRadius: 8}} />;
  }

  return (
    <OrderCountCard
      totalOrders={safeStats.invoicesCount ?? 0}
      numPaid={safeStats.paidInvoicesCount ?? 0}
      numUnpaid={safeStats.unpaidInvoicesCount ?? 0}
      numInProgress={safeStats.inProgressInvoicesCount ?? 0}
      startDate={start}
      endDate={end}
    />
  );
}
